export default class MessageTemplateService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('message_templates', params)
	}

	createEntity(params) {
		return this.apiService.callPost('message_templates', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('message_templates/' + id, params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('message_templates/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('message_templates/' + id, params)
	}

}



// WEBPACK FOOTER //
// ./src/service/MessageTemplateService.js